// useraccount home page

import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, ThemeProvider } from '@mui/material';
import getTheme from '../../theme/theme';
import { useNavigate } from 'react-router-dom';
import { OrganizationFinal } from './Userrole';
import axios from 'axios';
import { BASEURL } from '../../constants/Common';
import FloatingButton from '../usersupport/helpdesk/FloatingButton';

const UserAccountPage: React.FC = () => {
  const [organizationfinal, setOrganizationFinal] =
    useState<OrganizationFinal | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  // organization id
  const storedData = localStorage.getItem('orgid');
  let parsedData: any = null; // Define parsedData variable with 'any' type

  if (storedData) {
    parsedData = JSON.parse(storedData);
  } else {
    navigate('/login')
  }
  const organizationid = parsedData;

  // user id
  const storedAdmindata = localStorage.getItem('userRoleAdmin');
  let UserroleAdmin: any = null;

  if (storedAdmindata) {
    UserroleAdmin = JSON.parse(storedAdmindata);
  } else {
    console.log('No data found in localStorage');
  }
  const [userRole, setUserRole] = useState<string>(UserroleAdmin);
  const buttonStyles = {
    padding: '50px 50px', // Adjusted padding for all buttons
    fontSize: '1.1rem', // Adjusted font size for all buttons
    margin: '20px', // Added margin for spacing between buttons and rows
    width: '250px', // Example width
    height: '200px', // Example width
    borderRadius: '24px', // Rounded corners
  };

  const isSubscriptionExpired = (status: string | undefined): boolean => {
    return status === 'Expired';
  };

  
  const handleCreateNew = () => {
    navigate('/userrole');
  };

  const handleCreateNewdirectory = () => {
    navigate('/directory');
  };

  const handleAddNewuser = () => {
    navigate('/adduser');
  };

  const handleEditNewuser = () => {
    navigate('/editormodifyuser');
  };
  const isUserAdmin = userRole === 'Admin';

  useEffect(() => {
    const fetchOrganization = async () => {
      try {
        const response = await axios.get(
          BASEURL + '/organization' + `/${organizationid}/`,
          {
            headers: {
              Accept: 'application/json',
            },
          }
        );
        setOrganizationFinal(response.data);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };
    fetchOrganization();
  }, []);

  return (
    <ThemeProvider theme={getTheme()}>
      <Box sx={{ marginTop: '-60px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant='h5' component='div'>
              User Account Home
            </Typography>
        </Box>

        <Box sx={{ marginTop: '20px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              variant='contained'
              color='primary'
              sx={buttonStyles}
              onClick={handleCreateNew}
            >
              User Roles
            </Button>

            <Button
              variant='contained'
              color='primary'
              sx={buttonStyles}
              onClick={handleCreateNewdirectory}
            >
              Directory
            </Button>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '16px',
            }}
          >
            {isUserAdmin &&
              organizationfinal?.organization
                ?.organization_subscription_status === 'Active' &&
              organizationfinal?.organization?.active_users_count <
                organizationfinal?.subscription_plan?.users &&
              !isSubscriptionExpired(
                organizationfinal?.organization
                  ?.organization_subscription_status
              ) && (
                <Button
                  variant='contained'
                  color='primary'
                  sx={buttonStyles}
                  onClick={handleAddNewuser}
                >
                  Add User
                </Button>
              )}
            <Button
              variant='contained'
              color='primary'
              sx={buttonStyles}
              onClick={handleEditNewuser}
            >
              View/Modify Account details
            </Button>
          </Box>
        </Box>
        <FloatingButton/>
      </Box>
    </ThemeProvider>
  );
};

export default UserAccountPage;
